import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg80Lock = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80"
  }, props), {}, {
    children: [/*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "80-lock_svg__a",
        width: "130.3%",
        height: "129.4%",
        x: "-15.2%",
        y: "-11.8%",
        filterUnits: "objectBoundingBox",
        children: [/*#__PURE__*/jsx("feOffset", {
          dy: 2,
          "in": "SourceAlpha",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          "in": "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: 3
        }), /*#__PURE__*/jsx("feColorMatrix", {
          "in": "shadowBlurOuter1",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.103855373 0"
        })]
      }), /*#__PURE__*/jsx("path", {
        id: "80-lock_svg__b",
        d: "M39 6c13.703 0 24.93 10.6 25.928 24.048A9 9 0 0 1 73 39v26a9 9 0 0 1-9 9H16a9 9 0 0 1-9-9V39a9 9 0 0 1 6.043-8.503C13.821 16.837 25.145 6 39 6m.5 35a7.5 7.5 0 0 0-3.415 14.18A4 4 0 0 0 36 56v9a4 4 0 1 0 8 0v-9c0-.468-.08-.918-.228-1.335A7.5 7.5 0 0 0 39.5 41M39 14.21c-9.149 0-16.684 6.907-17.678 15.79h35.356c-.994-8.883-8.53-15.79-17.678-15.79"
      })]
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("use", {
        xlinkHref: "#80-lock_svg__b",
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
        filter: "url(#80-lock_svg__a)"
      }), /*#__PURE__*/jsx("use", {
        xlinkHref: "#80-lock_svg__b",
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      })]
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg80Lock$1 = Svg80Lock;

export { Svg80Lock$1 as default };
